// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure the DateRange picker respects MUI Joy theme */
.custom-date-range-picker {
    background-color: var(--joy-palette-background-surface) !important;
    color: var(--joy-palette-text-primary) !important;
    border: 1px solid var(--joy-palette-divider) !important;
  }
  
  /* Update calendar background */
  .custom-date-range-picker .rdrCalendarWrapper,
  .custom-date-range-picker .rdrMonth {
    background-color: var(--joy-palette-background-surface) !important;
    color: var(--joy-palette-text-primary) !important;
  }
  
  /* Update selected date colors */
  .custom-date-range-picker .rdrSelected,
  .custom-date-range-picker .rdrInRange {
    background-color: var(--joy-palette-primary-softBg) !important;
  }
  
  /* Update text inside days */
  .custom-date-range-picker .rdrDayNumber span {
    color: var(--joy-palette-text-primary) !important;
  }
  
  /* Update button colors */
  .custom-date-range-picker .rdrNextPrevButton {
    background-color: var(--joy-palette-neutral-softBg) !important;
    color: var(--joy-palette-text-primary) !important;
  }
  
  .custom-date-range-picker .rdrNextPrevButton:hover {
    background-color: var(--joy-palette-neutral-solidBg) !important;
  }

/* Chart.js legend checkmarks */
.chart-legend-clickable .legend-item::before {
  content: '✓';
  position: absolute;
  left: 2px;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  font-size: 10px;
  font-weight: bold;
  text-shadow: 1px 1px 1px rgba(0,0,0,0.5);
  z-index: 10;
  pointer-events: none;
}

.chart-legend-clickable .legend-item {
  position: relative;
  cursor: pointer !important;
}

/* Alternative: Add checkmark overlay using CSS */
.clickable-legend-box::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 10px;
  font-weight: bold;
  text-shadow: 1px 1px 1px rgba(0,0,0,0.8);
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/CallAnalytics/styles/styles.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;IACI,kEAAkE;IAClE,iDAAiD;IACjD,uDAAuD;EACzD;;EAEA,+BAA+B;EAC/B;;IAEE,kEAAkE;IAClE,iDAAiD;EACnD;;EAEA,gCAAgC;EAChC;;IAEE,8DAA8D;EAChE;;EAEA,4BAA4B;EAC5B;IACE,iDAAiD;EACnD;;EAEA,yBAAyB;EACzB;IACE,8DAA8D;IAC9D,iDAAiD;EACnD;;EAEA;IACE,+DAA+D;EACjE;;AAEF,+BAA+B;AAC/B;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,iDAAiD;AACjD;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,oBAAoB;AACtB","sourcesContent":["/* Ensure the DateRange picker respects MUI Joy theme */\n.custom-date-range-picker {\n    background-color: var(--joy-palette-background-surface) !important;\n    color: var(--joy-palette-text-primary) !important;\n    border: 1px solid var(--joy-palette-divider) !important;\n  }\n  \n  /* Update calendar background */\n  .custom-date-range-picker .rdrCalendarWrapper,\n  .custom-date-range-picker .rdrMonth {\n    background-color: var(--joy-palette-background-surface) !important;\n    color: var(--joy-palette-text-primary) !important;\n  }\n  \n  /* Update selected date colors */\n  .custom-date-range-picker .rdrSelected,\n  .custom-date-range-picker .rdrInRange {\n    background-color: var(--joy-palette-primary-softBg) !important;\n  }\n  \n  /* Update text inside days */\n  .custom-date-range-picker .rdrDayNumber span {\n    color: var(--joy-palette-text-primary) !important;\n  }\n  \n  /* Update button colors */\n  .custom-date-range-picker .rdrNextPrevButton {\n    background-color: var(--joy-palette-neutral-softBg) !important;\n    color: var(--joy-palette-text-primary) !important;\n  }\n  \n  .custom-date-range-picker .rdrNextPrevButton:hover {\n    background-color: var(--joy-palette-neutral-solidBg) !important;\n  }\n\n/* Chart.js legend checkmarks */\n.chart-legend-clickable .legend-item::before {\n  content: '✓';\n  position: absolute;\n  left: 2px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: white;\n  font-size: 10px;\n  font-weight: bold;\n  text-shadow: 1px 1px 1px rgba(0,0,0,0.5);\n  z-index: 10;\n  pointer-events: none;\n}\n\n.chart-legend-clickable .legend-item {\n  position: relative;\n  cursor: pointer !important;\n}\n\n/* Alternative: Add checkmark overlay using CSS */\n.clickable-legend-box::after {\n  content: '✓';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  font-size: 10px;\n  font-weight: bold;\n  text-shadow: 1px 1px 1px rgba(0,0,0,0.8);\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
